export enum ServiceOrderStatus {
  OPEN = "OPEN",
  IN_PROGRESS = "IN_PROGRESS",
  PAUSED = "PAUSED",
  READY = "READY",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}
